import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full max-w-lg rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }
const _hoisted_3 = {
  key: 0,
  class: "text-catering-ink-500"
}
const _hoisted_4 = { class: "mb-1 text-catering-ink-900" }
const _hoisted_5 = { class: "text-lg font-semibold tabular-nums" }
const _hoisted_6 = { class: "text-xs text-catering-ink-500" }
const _hoisted_7 = {
  key: 2,
  class: "mt-1 text-xs text-catering-ink-500"
}


export default {
  __name: 'BotGeocodingCoverage',
  props: { block: { type: Object, required: true } },
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, " Geocoded customer addresses · last " + _toDisplayString(__props.block.days) + " days ", 1),
    (!__props.block.addressed_orders)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " No orders with a saved address in this window. "))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(__props.block.coverage_percent) + "%", 1),
            _cache[0] || (_cache[0] = _createTextVNode(" of addressed orders have coordinates ", -1))
          ]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(__props.block.geocoded) + " geocoded · " + _toDisplayString(__props.block.missing) + " missing of " + _toDisplayString(__props.block.addressed_orders) + " addressed " + _toDisplayString(__props.block.addressed_orders === 1 ? 'order' : 'orders') + " (delivery + shipping) ", 1)
        ], 64)),
    (__props.block.map_zone_methods)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.block.map_zone_methods) + " fulfillment " + _toDisplayString(__props.block.map_zone_methods === 1 ? 'method uses' : 'methods use') + " a map-drawn zone (missing coordinates exclude an address from those). ", 1))
      : _createCommentVNode("", true)
  ]))
}
}

}